<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Allowance Types"
      text="Edit Allowance Type"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="4"
            class="pb-0"
          >
            <v-text-field
              v-model="localAllowancePenaltyType.name"
              v-validate="'required'"
              :error-messages="errors.collect('name')"
              data-vv-name="name"                
              label="Name"
            />
          </v-col>
          <v-col 
            cols="4"
            class="pb-0"
          >
            <v-text-field
              v-model="localAllowancePenaltyType.rate"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('rate')"
              data-vv-name="rate"                
              label="Rate"
            />
          </v-col>
          <v-col 
            cols="4"
            class="pb-0"
          >
            <v-autocomplete
              v-model="localAllowancePenaltyType.unit_of_measurement_id"
              v-validate="'required'"
              :error-messages="errors.collect('unit_of_measurement_id')"
              :items="unitOfMeasurements"
              data-vv-name="id"
              data-vv-as="unit_of_measurement_id"   
              item-text="name"
              item-value="id"
              label="Unit"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="3"
            class="pb-0"
          >
            <span> Is EPF Contribute? </span>
            <v-radio-group
              v-model="localAllowancePenaltyType.is_epf_contribute"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>
          <v-col 
            cols="3"
            class="pb-0"
          >
            <span> Is EIS Contribute? </span>
            <v-radio-group
              v-model="localAllowancePenaltyType.is_eis_contribute"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>
          <v-col 
            cols="3"
            class="pb-0"
          >
            <span> Is SOCSO Contribute? </span>
            <v-radio-group
              v-model="localAllowancePenaltyType.is_socso_contribute"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>
          <v-col 
            cols="3"
            class="pb-0"
          >
            <span> Is Taxable? </span>
            <v-radio-group
              v-model="localAllowancePenaltyType.is_pcb"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="3"
            class="pb-0"
          >
            <span> Is Negative? </span>
            <v-radio-group
              v-model="localAllowancePenaltyType.is_negative"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>
          <v-col 
            cols="3"
            class="pb-0"
          >
            <span> Is Additional Remuneration? </span>
            <v-radio-group
              v-model="localAllowancePenaltyType.is_additional_remuneration"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>
          <v-col 
            cols="3"
            class="pb-0"
          >
            <span> Is Fixed? </span>
            <v-radio-group
              v-model="localAllowancePenaltyType.is_fixed"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>
          <v-col 
            cols="3"
            class="pb-0"
          >
            <span> Is Hrdf? </span>
            <v-radio-group
              v-model="localAllowancePenaltyType.is_hrdf"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="localAllowancePenaltyType.tax_relief_category"
              :error-messages="errors.collect('taxReliefCategory')"
              :items="taxRelief"
              data-vv-name="id"
              data-vv-as="taxReliefCategory"   
              :item-text="item => '['+item.year+'] '+item.name"
              item-value="category"
              label="Tax Relief Type"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            class="pb-0"
          >
            <v-textarea
              v-model="localAllowancePenaltyType.description"
              v-validate="'max:1000'"
              :rows="1"
              :error-messages="errors.collect('value')"     
              data-vv-name="description"           
              data-vv-as="description"
              label="Description"
            />
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  export default {
    inject: ['$validator'],
    props: {
      allowancePenaltyType: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localAllowancePenaltyType: null,
        unitOfMeasurements: [],
        taxRelief: [],
        taxReliefCategory: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localAllowancePenaltyType = { ...this.allowancePenaltyType }
        if (this.localAllowancePenaltyType.rate) { this.localAllowancePenaltyType.rate = this.localAllowancePenaltyType.rate / 100 }
        this.loadUnitOfMeasurements()
        this.loadTaxRelief()
      },
    },
    mounted () {
      let _this = this

      this.$validator.extend('twoDecimalValue', {
        getMessage (field, args) {
          return 'Only 2 Decimals are allowed'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)
            this.$api.allowancePenaltyTypes().update(this.allowancePenaltyType.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
                this.dialog = false 
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          name: this.localAllowancePenaltyType.name,
          rate: this.localAllowancePenaltyType.rate,
          unit_of_measurement_id: this.localAllowancePenaltyType.unit_of_measurement_id,
          is_negative: this.localAllowancePenaltyType.is_negative,
          is_epf_contribute: this.localAllowancePenaltyType.is_epf_contribute,
          is_eis_contribute: this.localAllowancePenaltyType.is_eis_contribute,
          is_socso_contribute: this.localAllowancePenaltyType.is_socso_contribute,
          is_pcb: this.localAllowancePenaltyType.is_pcb,
          tax_relief_category: this.localAllowancePenaltyType.tax_relief_category,
          is_additional_remuneration: this.localAllowancePenaltyType.is_additional_remuneration,
          is_fixed: this.localAllowancePenaltyType.is_fixed,
          is_hrdf: this.localAllowancePenaltyType.is_hrdf,
          description: this.localAllowancePenaltyType.description,
        }
      },
      loadUnitOfMeasurements () {
        this.$api.unitOfMeasurements().list()
          .then((res) => {
            this.unitOfMeasurements = res.data
          })
          .catch(() => {})
      },
      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
      loadTaxRelief () {
        this.$api.taxRelief().list()
          .then(res => {
            this.taxRelief = res.data
          })
      },
    },
  }
</script>
